export const cutTextByNumberOfSymbols = ({ text, numberOfSymbols } : {text: string, numberOfSymbols: number}) => text.length > numberOfSymbols ? `${text.substring(0, numberOfSymbols - 1)}...` : text
